import Vue from 'vue';

// find all files in the current directory ending with .vue
const requireComponent = require.context('.', false, /.*\.vue$/);

// register each as a global Vue component
requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.replace(/^\.\//, '').replace(/\.vue$/, '');
  Vue.component(componentName, componentConfig.default || componentConfig);
});
